import styled from 'styled-components'

const CallText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
`
export default CallText
